import { Row } from "react-bootstrap";
import SearchSerialNumber from "./SearchSerialNumber";
import SearchDocument from "./SearchDocument";

export default function Search() {
  return (
    <>
      <Row>
        <h4>Search</h4>
      </Row>
      <Row>
        <SearchSerialNumber />
        <SearchDocument />
      </Row>
    </>
  );
}
